export default {
  message: {
    "error": "Ops! Algo deu errado.",
    "Sorrysomeerrorsoccurred": "Um erro inesperado ocorreu. Você pode tentar mudar o idioma ou sair e reiniciar o aplicativo.",
    "quit": "Sair",
    "language": "Idioma",
    "Youcanchangethelanguagehere": "Você pode mudar o idioma aqui!",
    "current": "Atual",
    "home": "Início",
    "friends": "Amigos",
    "wallet": "Carteira",
    "aboutus": "Sobre Nós",
    "Sharewithfriends": "Compartilhar com amigos",
    "copyFailure": "Falha ao copiar",
    "copySuccess": "Sucesso ao copiar",
    "Claimreward": "Receber recompensa",
    "DailyLogin": "Login Diário",
    "noInvitationsYet": "Nenhum convite ainda",
    "LoadMore": "Carregar Mais",
    "WatchAD": "Assistir ANÚNCIO",
    "continue": "Continuar",
    "Congratulations": "Parabéns",
    "MyFriends": "Meus Amigos",
    "Invitefriends": "Convidar amigos",
    "Invitepremiumfriends": "Convidar amigos premium",
    "DailyTasks": "Tarefas diárias",
    "inviteDesc": "+{num} ${name} para cada amigo que você convidar",
    "DailyTasksDesc": "Complete tarefas para receber mais airdrop",
    "SponsorsandPartners": "Patrocinadores e Parceiros",
    "Receivingwallet": "Carteira de recebimento",
    "Enterwalletaddress": "Digite o endereço da carteira {name}",
    "Claim": "Receber",
    "Booster": "Acelerador",
    "RentPeriod": "Período de aluguel",
    "days30": "30 dias",
    "Dailyprofit": "Lucro diário",
    "Totalprofit": "Lucro total",
    "Quantity": "Quantidade",
    "RentPrice": "Preço do aluguel",
    "RentMiner": "Alugar Minerador",
    "Insufficient": "Convites insuficientes",
    "InsufficientMsg": "Você precisa convidar {num} amigos para ganhar mais acessórios.",
    "Settings": "Configurações",
    "copyid": "Copiar ID",
    "UpgradeSuccessfully": "Aperfeiçoado com sucesso",
    "Name": "Nome",
    "userinfo": "Informações do usuário",
    "disconnect": "Desconectar",
    "Startmining": "Começar a minerar",
    "Welcome": "Bem-vindo ao {name}",
    "Withdrawal": "Retirada",
    "Minimumamount": "Quantidade mínima",
    "Networkfee": "Taxa de rede",
    "Enteramount": "Insira a quantia",
    "Submit": "Enviar",
    "MinimumTip": "O valor de retirada é muito pequeno. Valor mínimo de retirada: {num}",
    "MaximumTip": "Valor insuficiente, o valor máximo que você pode retirar é: {num}",
    "SubmittedTip": "Enviado, espera-se que seja processado em 30-60 dias úteis",
    "WithdrawStatus": "Status",
    "Submissiontime": "Hora da submissão",
    "WithdrawAwaitTip": "* Estima-se que leve de 30 a 60 dias úteis. Convidar mais amigos pode acelerar o processo de revisão.",
    "Processing": "Processando",
    "Amount": "Quantia",
    "Numberoffriends": "Número de amigos: {now}/{limit}",
    "InviteTip": "Para completar o processo de retirada, você precisa convidar {limit} amigos para entrar no aplicativo de mineração.",
    "openonphone": "Abra este link no seu telefone.",
    "claimTip": "O valor a ser coletado é muito pequeno. O valor mínimo a ser coletado é: {num}",
    "WalletBalance": "Saldo da carteira",
    "Withdraw": "Retirar",
    "SetWalletAddress": "Definir endereço da carteira",
    "WithdrawalRecord": "Registro de retiradas",
    "Norecords": "Sem registros",
    "Whatis": "O que é {name}?",
    "All": "Todos",
    "save": "Salvar",
    "successWithdrawal": "Escaneamento bem-sucedido {num}",
    "secondsago": "{time} segundos atrás",
    "Loading": "Carregando...",
    "PaymentConfirming": "Verificando Status da Transação...",
    "Check": "Verificar",
    "CheckFail": "Transação não concluída. Por favor, verifique novamente em 5 segundos.",
    "Addname": "Adicionar '{name}' ao seu nome",
    "Restattcheck": "Reinicie o aplicativo para verificar",
    "Copyname": "COPIAR '{name}'",
    "SubmissionFailed": "Submissão falhou, por favor tente novamente mais tarde",
    "WithdrawalReview": "Revisão da retirada",
    "WebWithdrawAwaitTip": "* Estima-se que leve de 24 a 48 horas. Convidar mais amigos pode acelerar o processo de revisão.",
    "Success": "Sucesso",
    "Rejection": "Rejeição",
    "WebSubmittedTip": "Enviado, iremos processar assim que possível.",
    "select_payment_method": "Selecionar método de pagamento",
    "total_amount": "Valor total",
    "next_step": "Próximo passo",
    "creating_order": "Criando pedido...",
    "order_created": "Pedido criado",
    "order_status": "Status do pedido",
    "order_id": "ID do pedido",
    "order_amount": "Valor do pedido",
    "order_status_desc": "Descrição do status do pedido",
    "payment_cancelled": "Pagamento cancelado",
    "opening_payment": "Abrindo pagamento...",
    "payment_success": "Pagamento bem-sucedido",
    "payment_failed": "Pagamento falhou",
    "payment_pending": "Pagamento pendente",
    "payment_processing": "Processando pagamento",
    "create_order_failed": "Falha ao criar pedido",
    "creating_ton_order": "Criando pedido TON...",
    "check_payment_status": "Verificando status do pagamento...",
    "use_ton_payment": "Usar pagamento TON",
    "connect_wallet": "Conectar carteira",
    "start_transaction": "Iniciar transação",
    "address": "Endereço",
    "amount_ton": "Quantidade TON",
    "copy": "Copiar",
    "comment_memo": "Comentário memo",
    "comment_memo_desc": "Por favor, insira o comentário memo",
    "comment_memo_placeholder": "Insira comentário memo",
    "amount": "Quantidade",
    "wallet_address": "Endereço da carteira",
    "you_can_choose_to_connect_wallet_to_pay": "Você pode optar por conectar a carteira para pagar",
    "or_manually_transfer_to_the_above_address": "Ou transferir manualmente para o endereço acima (note que a quantidade e o memo devem ser exatamente os mesmos)",
    "transaction_success": "Transação bem-sucedida",
    "transaction_failed": "Transação falhou",
    "transaction_error": "Erro na transação",
    "transaction_status": "Status da transação",
    "transaction_id": "ID da transação",
    "transaction_amount": "Quantidade da transação",
    "transaction_status_desc": "Descrição do status da transação",
    "miner_detail": "Detalhe do minerador",
    "rent_period": "Duração do aluguel",
    "days": "{days} dias",
    "daily_yield": "Rendimento diário",
    "total_yield": "Rendimento total",
    "invite_friends": "Convidar amigos",
    "price": "Preço",
    "rent": "Aluguel",
    "free_claim": "Recompensa gratuita",
    "redeem": "Resgatar",
    "buy": "Aluguel",
    "invite_friends_not_enough": "Convite para amigos não é suficiente",
    "redeem_success": "Resgate bem-sucedido",
    "redeem_failed": "Resgate falhou",
    "rent_success": "Aluguel bem-sucedido",
    "rent_failed": "Aluguel falhou",
    "TotalPower": "Poder total",
    "MaxQuantity": "Valor máximo alcançado",
    "Running": "Executando",
    "Stop": "Parar",
    "InviteTipFirst": "Para fazer sua primeira retirada, você precisa convidar {limit} amigos para entrar no aplicativo de mineração.",
    "Withdrawalunlock": "Desbloqueio de retirada",
    "Close": "Fechar",
    "Delivering": "Entregando",
    "Duetothelargenumber": "Devido ao grande número de recebedores, seu airdrop deve chegar em 15-20 dias úteis",
    "WithdrawalunlockTip": "Você precisa de {num} amigos convidados para completar tarefas/vincular carteiras para desbloquear a retirada",
    "mining_title": "Robô",
    "Upgrade": "Atualizar",
    "partner": "Parceiro",
    "faq": "Perguntas Frequentes",
    "task": "Tarefa",
    "OpenRobot": "Abrir Robô",
    "MyRobot": "Meu Robô",
    "Level": "Nível",
    "Commission": "Comissão",
    "DirectFriends": "Amigos Diretos",
    "Feedback": "Feedback",
    "Pleaseenteryouremailaddress": "Por favor, insira seu endereço de e-mail",
    "Inputfeedbackcontent": "Digite o conteúdo do feedback",
    "Submitfeedback": "Enviar feedback",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Feedback enviado com sucesso, obrigado pelo seu valioso feedback",
    "Feedbacksubmissionfailed,pleaseretriy": "Falha ao enviar feedback, por favor, tente novamente",
    "Addressformaterror": "Erro no formato do endereço",
    "Readclipboardfailed": "Falha ao ler a área de transferência",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Você já enviou feedback hoje, por favor, volte amanhã",
    "Record": "Registro",
    "Newuserguidance": "Ver Tour de Boas-Vindas",
    "Usetonwallet": "Usar carteira TON",
    "Reward": "Recompensa",
    "Connectwallet": "Conectar carteira",
    "Notconnected": "Não conectado",
    "Disconnect": "Desconectar",
    "AboutTAI": "Detalhes do Token",
    "WithdrawalRecordDesc": "Registro de retirada",
    "StartAItrading": "Começar negociação de IA",
    "Next": "Próximo",
    "Start": "Iniciar",
    "WithdrawalSuccess": "Retirada bem-sucedida",
    "WithdrawalFail": "Falha na retirada",
    "Max": "Máx",
    "WithdrawalRecords": "Registros de Retirada",
    "Commissionrules": "Regras de comissões",
    "Mycommission": "Minha comissão",
    "Shop": "Loja",
    "BuyDifferentAIrobots": "Aperfeiçoe com dispositivos de computação para escaneamentos mais rápidos!",
    "CurrentRunningAIrobots": "Robôs de IA em funcionamento",
    "DailyProfit": "Lucro diário",
    "Buy": "Comprar",
    "ValidityPeriod": "Período de validade",
    "Days": "Dias",
    "Price": "Preço",
    "APY": "APY",
    "NoRobot": "Sem poder de computação",
    "RemainingTime": "Tempo restante",
    "InviteandEarn": "Convide e ganhe",
    "InvitDec": "Convide seus amigos a participar do trading de IA e ganhe comissões em USDT e tokens de airdrop juntos!",
    "ShareToGroups": "Compartilhe em grupos",
    "Select_payment_method": "Selecionar método de pagamento",
    "twa_pay_tip_with_memo": "Por favor, certifique-se de que o endereço, o valor e o memo estejam consistentes para a transferência.",
    "twa_pay_tip": "Por favor, certifique-se de que o endereço e o valor estão corretos para a transferência.",
    "twa_pay_tip_placeholder": "Digite o comentário",
    "twa_pay_tip_placeholder_with_memo": "Digite o comentário com memo",
    "twa_pay_tip_placeholder_without_memo": "Digite o comentário sem memo",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Digite o comentário com memo",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Digite o comentário sem memo",
    "realtime_ai": "Negociação de IA em Tempo Real",
    "check_transaction_status": "Verificar status da transação",
    "transaction_wait": "A transação está em processamento. Você pode sair do aplicativo. Uma mensagem o notificará assim que estiver concluída.",
    "Pleaseenteravalidemailaddress": "Por favor, insira um endereço de e-mail válido",
    "max_robot_tip": "Limite de compra alcançado — experimente outro plano para continuar negociando!",
    "connectFailure": "Falha ao conectar a carteira",
    "connectSuccess": "Conexão da carteira bem-sucedida",
    "PayNow": "Pagar agora",
    "min_withdrawal_amount": "O valor mínimo de retirada é {num} {coin_name}",
    "max_withdrawal_amount": "O valor máximo de retirada é {num} {coin_name}",
    "balance_not_enough": "Você não tem saldo suficiente para esta retirada.",
    "Numberofgroups": "Número de grupos: {now}/{limit}",
    "Withdraw_success": "Retirada bem-sucedida",
    "allProfit": "Lucro total",
    "AnnualProfit": "Lucro anual",
    "ScanWallet": "Escanear Carteira",
    "wallet_check": "wallet_check",
    "Found": "Encontrado",
    "ScanSpeed": "Velocidade de escaneamento",
    "MyComputingPower": "Computar",
    "Scanning": "Escaneando!",
    "WithdrawDetail": "Detalhes do saque",
    "ScanSuccess": "A sua taxa de sucesso de digitalização aumentou!",
    "TaskDescription": "Complete tarefas para aumentar sua taxa de sucesso na digitalização!",
    "InitializingMiningSystem": "Inicializando o sistema de scan...",
    "NoWithdrawalRecord": "Sem registro de retirada",
    "Invite": "Convites necessários",
    "Free": "Gratuito",
    "Confirm": "Confirmar",
    "RefreshTasks": "Atualizar tarefas",
    "NumberofGroups": "Número de grupos: {now}/{limit}",
    "SendMessage": "Enviar mensagem",
    "NumberofShares": "Número de ações: {now}/{limit}",
    "NumberofTasks": "Número de tarefas: {now}/{limit}",
    "CompleteTask": "Completar tarefa",
    "Accelerated": "Acelerado",
    "Accelerated_withdrawals_success": "Retiradas aceleradas com sucesso",
    "GoBuy": "Ir Comprar",
    "SpeedUpScan": "Acelerar",
    "Earnings": "Ganhos",
    "learnMore": "Saiba mais",
    "claimSuccess": "Recompensa recebida com sucesso",
    "claimFailed": "Falha ao receber, por favor tente novamente",
    "noDividends": "Sem dividendos a receber",
    "dividendsInfoFallback": "Convide amigos para ganhar recompensas de indicação"
}};